<template>
    <GuidesListDefault v-if="slice.variation === 'default'" :slice="slice" />
    <GuidesListSelection v-else :slice="slice" />
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {GuidesListSlice} from '@prismicio-types';
    import GuidesListDefault from './GuidesListDefault.vue';
    import GuidesListSelection from './GuidesListSelection.vue';
    defineProps({
        ...getSliceComponentProps<GuidesListSlice>(),
    });
</script>
